import { render, staticRenderFns } from "./StatsPage.vue?vue&type=template&id=2a30c6e3&"
import script from "./StatsPage.vue?vue&type=script&lang=ts&"
export * from "./StatsPage.vue?vue&type=script&lang=ts&"
import style0 from "./StatsPage.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports